import React from 'react'
import { Textarea } from '@wmgtech/legato'
import { useController } from 'react-hook-form'

import { FormTextAreaProps } from './FormTextArea.props'

function TextAreaForm<T extends Record<string, any>>({ fieldName, control, warning, ...rest }: FormTextAreaProps<T>) {
  const {
    field,
    fieldState: { error }
  } = useController<T>({
    name: fieldName,
    control
  })
  return (
    <Textarea
      {...rest}
      {...field}
      validation={
        warning?.isShow && !error
          ? { message: warning?.message, type: 'warning' }
          : {
            message: error?.message,
            ...(error && { type: 'error' })
          }
      }
    />
  )
}

export const FormTextArea = TextAreaForm as <T extends Record<string, any>>(
  props: FormTextAreaProps<T>
) => ReturnType<typeof TextAreaForm>
